const duo = {
  browserShellSize: 38,
  foldSize: 28,
  landscape: {
    width: 928,
    height: 600
  },
  portrait: {
    width: 600,
    height: 928
  }
}

const neo = {
  browserShellSize: 38,
  foldSize: 0,
  landscape: {
    width: 1440,
    height: 960
  },
  portrait: {
    width: 960,
    height: 1440
  }
}


export default { duo, neo }